module.exports = __webpack_public_path__ + "img/grc.471d733a.svg";